import logo from "common/assets/logo-long-small.png";

export function FullPageSpinner() {
  return (
    <div
      style={{
        fontSize: "1rem",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#1d1c1c",
        color: "#fff",
      }}
    >
      <img
        src={logo}
        alt="Loading route"
        style={{
          width: 165,
          marginBottom: 8,
        }}
      />
      <p>Loading...</p>
    </div>
  );
}
